import './style';
import './tailwind.css';
import App from './app';

export default App;
